import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useForm, useFieldArray } from 'react-hook-form';
import { addProject, verifyAdmin } from '../../../utils/api';
import Loading from '../../../shared/Loading/Loading';
import { toast } from 'react-hot-toast';
import './Dashboard.css'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AdminCredential from '../../../auth/AdminCredential'
import AdminCredentialModal from '../../../auth/AdminCredentialModal'
import {
  useDisclosure,
} from '@chakra-ui/react'

function AddProject() {
  const [showForm, setShowForm] = useState(false);


  const { handleSubmit, register, control } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'technology',
  });


  const { mutateAsync: createProject, isLoading, isError, error } = useMutation(addProject, {
    onSuccess: (data) => {
      console.log(data);
      // Update UI or perform any other actions after project creation
    },
  });
  
  const [overlay, setOverlay] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openCredentialModal = () => {
    setOverlay(<AdminCredential />);
    onOpen();
  };

  const closeCredentialModal = () => {
    setOverlay(null);
    onClose();
  };

  const onSubmit = async (data) => {
    try {
   const token = localStorage.getItem('tokenId');
      if (!token) {
        const alertResult = await Swal.fire({
          title: 'Admin Credential Required',
          text: 'To add a project, you need valid admin credentials. Would you like to provide them?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          background: 'rgba(0, 0, 0, 0.9)',
          confirmButtonColor: "#DF7E07",
        });

        if (alertResult.isConfirmed) {
          // Open the admin credential modal
          openCredentialModal();
        }
      } else {
        const isAdmin = await verifyAdmin(token);
        if (isAdmin) {
          await createProject(data);
          toast.success('Project added successfully');
        } else {
          toast.error('You do not have permission to add a project.');
        }
      }
    } catch (error) {
      console.error('Error creating data:', error);
      toast.error('An error occurred');
    }
  };

if (isLoading) {
  return <Loading/>
}

if (error) {
  return <div>Error: {error.message}</div>;
}

  return (
    <>
 <AdminCredentialModal isOpen={isOpen} onClose={closeCredentialModal} overlay={overlay} />


   <form onSubmit={handleSubmit(onSubmit)} className="container mx-auto px-16 mt-14 lg:mb-8">
    <div className="md:col-span-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="mb-4 md:mb-0">
          <label htmlFor="image">Image:</label>
          <input
            type="text"
            id="image"
            {...register('links.image')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter image URL"
          />
        </div>
          <div className="mb-4 md:mb-0">
          <label htmlFor="bannerImg">Banner Image:</label>
          <input
            type="text"
            id="bannerImg"
            {...register('links.bannerImg')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter Banner image URL"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="live">Live:</label>
          <input
            type="text"
            id="live"
            {...register('links.live')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter live URL"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="bigTitle">Big Title:</label>
          <input
            type="text"
            id="bigTitle"
            {...register('links.details.titleBig')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter big title"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="smallTitle">Small Title:</label>
          <input
            type="text"
            id="smallTitle"
            {...register('links.details.titleSmall')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter small title"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            {...register('links.details.desc')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter description"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="client">Client:</label>
          <input
            type="text"
            id="client"
            {...register('links.details.client')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter client"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="server">Server:</label>
          <input
            type="text"
            id="server"
            {...register('links.details.server')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter server"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="category">Category:</label>
          <select
            id="category"
            {...register('category')}
            className="w-full border border-gray-300 rounded p-2"
          >
            <option value="all">All</option>
            <option value="Advance Web">Advance Web</option>
            <option value="Mern Stack">Mern Stack</option>
            <option value="data science">Data Science</option>
            <option value="python">Python</option>
            <option value="web">Web</option>
          </select>
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="date">Date:</label>
          <input
            type="date"
            id="date"
            {...register('date')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Select date"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="priority">Priority:</label>
          <input
            type="number"
            id="priority"
            {...register('priority')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter priority"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="slideImg1">Slide Image 1:</label>
          <input
            type="text"
            id="slideImg1"
            {...register('slide.img1')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter slide image 1 URL"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="slideImg2">Slide Image 2:</label>
          <input
            type="text"
            id="slideImg2"
            {...register('slide.img2')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter slide image 2 URL"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="slideImg3">Slide Image 3:</label>
          <input
            type="text"
            id="slideImg3"
            {...register('slide.img3')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter slide image 3 URL"
          />
        </div>
        <div className="mb-4 md:mb-0">
          <label htmlFor="slideImg4">Slide Image 4:</label>
          <input
            type="text"
            id="slideImg4"
            {...register('slide.img4')}
            className="w-full border border-gray-300 rounded p-2"
            placeholder="Enter slide image 4 URL"
          />
        </div>
        {/* added multiple fields */}
        <div className="mb-4 m-8 md:mb-0">
  <div className="flex items-center gap-3">
        <div>
        <label className="toggle-switch">
                <input
                type="checkbox"
                style={{ color: '#FFA001' }}
                className="toggle toggle-warning"
                checked={showForm}
                onChange={() => setShowForm(!showForm)}
              />

              <span className="toggle-slider"></span>
            </label>
        </div>
          <div>
          <label>Add Technology</label>
          </div>
  </div>


          {showForm && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {fields.map((field, index) => (
            <div key={field.id} className="flex flex-wrap">
              <div className="w-full gap-6 mb-4 md:mb-0">
                <input
                  {...register(`technology[${index}].techLeft`)}
                  defaultValue={field.techLeft}
                  className="w-full border border-gray-300 rounded p-2"
                  placeholder="Enter left technology"
                />
              </div>
              <div className="w-full mt-4">
                <input
                  {...register(`technology[${index}].techRight`)}
                  defaultValue={field.techRight}
                  className="w-full border border-gray-300 rounded p-2"
                  placeholder="Enter right technology"
                />
              </div>
              <button
                type="button"
                onClick={() => remove(index)}
                className="text-red-500 hover:text-red-700"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => append({})}
            className="col-span-2 bg-info text-white py-2 px-4 rounded"
          >
            Add Field
          </button>
        </div>
        
          )}
        </div>
      </div>
    </div>

    <button type="submit" className="col-span-2 w-full lg:w-[30%] bg-primary mt-7 mb-32 md:mb-0 text-white py-2 px-4 rounded">
      Submit
    </button>
</form>

    </>
  );
}

export default AddProject;
